import { Files } from '../../lib/constants/files'
import { Option } from '../../lib/types/models/options/option'
import { OptionInput } from '../../lib/types/models/options/option-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createOption(data: OptionInput) {
  let option = { ...data }
  const image = await uploadFile(Files.OPTION_PICTO, data.picto)
  const pic = await uploadFile(Files.OPTION_PICTURE, data.picture)
  option = { ...option, picto: image, picture: pic }
  return restApiClient
    .url(constructApiUrl(API.options.create.url, null))
    .post<Option, OptionInput>(option)
}
